import React from 'react'

function CopyrightFooter() {
  return (
    <>
      {/* Footer */}
      <div className="footer-copyright  bg-transparent">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p>
                Copyright © 2025. All Rights Reserved Webmobril Technologies
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* /Footer */}
    </>
  );
}

export default CopyrightFooter